import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSharingSettingsQuery } from '../../api/useSharingSettingsQuery';
import { AsyncComponentHookResult } from '../../../../../../Types/ComponentHookResult';
import { currentClientSelector } from '../../../../../../CommonSelectors/CommonAreaSelector';
import { AssigneeTypes } from '../../Tasks.types';

export interface AssignTo {
  label: string;
  value: number | null;
  type: AssigneeTypes;
}

export const useAssignList = (): AsyncComponentHookResult<AssignTo[]> => {
  const queryResult = useSharingSettingsQuery();
  const currentClient = useSelector(currentClientSelector);

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const advisorsList = queryResult.data.Relationships.map(
      ({ AdviserId, FirstName, LastName }) => ({
        value: AdviserId,
        label: `${FirstName} ${LastName}`,
        type: AssigneeTypes.Adviser,
      }),
    );

    const clientRelationsList: AssignTo[] = [];

    if (currentClient) {
      clientRelationsList.push({
        value: null,
        label: `${currentClient.FirstName} ${currentClient.LastName}`,
        type: AssigneeTypes.Primary,
      });
    }

    if (currentClient.PartnerName) {
      clientRelationsList.push({
        value: null,
        label: `${currentClient.PartnerName}`,
        type: AssigneeTypes.Partner,
      });
    }

    return [...clientRelationsList, ...advisorsList];
  }, [queryResult.data, currentClient]);

  return {
    ...queryResult,
    data,
  };
};
